import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";

function Eightstepcloud() {
  return (
    <section className="eight_step_cloud p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Our 8-Step Process for Cloud Migration Services</h2>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              // loop={true}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 4,
                },
                1600: {
                  slidesPerView: 4,
                },
              }}
              className="eight_step_cloud_slider"
            >
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Project Discovery &<br /> Planning
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Conducting comprehensive application and data warehouse
                        audits.
                      </li>
                      <li>
                        Performing rigorous security and compliance assessments.
                      </li>
                      <li>
                        Mapping dependencies and gathering detailed
                        requirements.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Data Migration
                        <br /> Strategy & Execution
                      </h5>
                    </div>

                    <ul>
                      <li>
                        Developing tailored data migration strategies for
                        complex datasets.
                      </li>
                      <li>
                        Implementing optimized data extraction, cleaning, and
                        loading processes.
                      </li>
                      <li>
                        Executing trial migrations to validate data integrity
                        and performance.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Application/DWH Architecture &<br /> Code Update
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Analyzing and updating application and data warehouse
                        architectures for cloud compatibility.
                      </li>
                      <li>
                        Refactoring code and optimizing database schemas for
                        cloud environments.
                      </li>
                      <li>
                        Implementing best practices for scalability,
                        reliability, and performance.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Mock or Pilot
                        <br /> Migration
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Conducting comprehensive mock migrations to assess
                        feasibility and identify potential issues.
                      </li>
                      <li>
                        Piloting migrations with small-scale workloads to
                        validate functionality and performance
                      </li>
                      <li>
                        Refining migration strategies based on mock or pilot
                        results.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Phased Workload
                        <br /> Migration
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Strategically planning phased migrations to minimize
                        disruptions and downtime.
                      </li>
                      <li>
                        Prioritizing workloads based on dependencies,
                        criticality, and complexity.
                      </li>
                      <li>
                        Monitoring and optimizing resource utilization during
                        workload migrations.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Testing &<br /> Deployment
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Conducting thorough testing to validate application
                        functionality and data integrity post-migration.
                      </li>
                      <li>
                        Implementing automated testing frameworks for continuous
                        integration and deployment.
                      </li>
                      <li>
                        Deploying migrated workloads in production environments
                        with minimal downtime.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Optimization &<br /> Performance Tuning
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Analyzing system performance post-migration and
                        optimizing resource allocation.
                      </li>
                      <li>
                        Implementing performance monitoring tools for proactive
                        issue detection and resolution.
                      </li>
                      <li>
                        Fine-tuning configurations for scalability, reliability,
                        and cost-efficiency.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Maintenance &<br /> Support
                      </h5>
                    </div>
                    <ul>
                      <li>
                        Providing ongoing maintenance and support services to
                        address post-migration issues.
                      </li>
                      <li>
                        Offering proactive monitoring and troubleshooting for
                        cloud environments.
                      </li>
                      <li>
                        Collaborating with stakeholders to implement continuous
                        improvements and optimizations.
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
               Migrate to Cloud
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Eightstepcloud;
